import { render } from "./OnboardingSummaryData.vue?vue&type=template&id=d29c34e0&scoped=true&ts=true"
import script from "./OnboardingSummaryData.vue?vue&type=script&lang=ts"
export * from "./OnboardingSummaryData.vue?vue&type=script&lang=ts"

import "./OnboardingSummaryData.vue?vue&type=style&index=0&id=d29c34e0&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d29c34e0"]])

export default __exports__